import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import QuoteModal from '@/components/PowerOcean/Home/QuoteModal';

export default function G({ langKey }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');
    const [showQuoteModal, setShowQuoteModal] = useState(false);

    const handleLearMore = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'solution_button',
                list_name: t('secG_title'),
                button_name: t('secA_btn'),
            });
        } catch (e) {
            console.error(e);
        } finally {
            if (langKey === 'solarspeicher') {
                const target = document.querySelector('.power-ocean-collection-N') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target?.offsetTop,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            setShowQuoteModal(true);
        }
    };

    return (
        <div className={`power-ocean-collection-G ${css['power-ocean-collection-G']}`}>
            <div className="inner-content">
                <div className="column menu">
                    <div className="title"></div>
                    <span className="props">{t('secG_prop1')}</span>
                    <span className="props">{t('secG_prop2')}</span>
                    <span className="props">{t('secG_prop3')}</span>
                    <span className="props">{t('secG_prop4')}</span>
                    <span className="props">{t('secG_prop5')}</span>
                    <span className="props">{t('secG_prop6')}</span>
                </div>
                <div className="column">
                    <div className="title">
                        <div className="title-img">
                            <NextImage
                                src={require('@publicLocal/power-ocean/collection/pc/de/7_1.png')}
                                alt={t('secG_item1_title')}
                                aria-label={t('secG_item1_title')}
                            />
                        </div>
                        <span className="title-text">{t('secG_item1_title')}</span>
                    </div>
                    <div className="row">{t('secG_item1_prop1')}</div>
                    <div className="row">
                        <p className="row-item">{t('secG_item1_prop2_1')}</p>
                        <p className="row-item">{t('secG_item1_prop2_2')}</p>
                        <p className="row-item">{t('secG_item1_prop2_3')}</p>
                    </div>
                    <div className="row">{t('secG_item1_prop3')}</div>
                    <div className="row row-combine1">
                        <p className="row-item">{t('secG_item1_prop4_1')}</p>
                        <p className="row-item">{t('secG_item1_prop4_2')}</p>
                        <p className="row-item">{t('secG_item2_prop4_1')}</p>
                        <p className="row-item">{t('secG_item2_prop4_2')}</p>
                    </div>
                    <div className="row">
                        <p className="row-item">{t('secG_item1_prop5_1')}</p>
                        <p className="row-item">{t('secG_item1_prop5_2')}</p>
                        <p className="row-item">{t('secG_item1_prop5_3')}</p>
                    </div>
                    <div className="row">{t('secG_item1_prop6')}</div>
                </div>
                <div className="column">
                    <div className="title">
                        <div className="title-img">
                            <NextImage
                                src={require('@publicLocal/power-ocean/collection/pc/de/7_2.png')}
                                alt={t('secG_item2_title')}
                                aria-label={t('secG_item2_title')}
                            />
                        </div>
                        <span className="title-text">{t('secG_item2_title')}</span>
                    </div>
                    <div className="row">{t('secG_item2_prop1')}</div>
                    <div className="row">{t('secG_item2_prop2')}</div>
                    <div className="row">{t('secG_item2_prop3')}</div>
                    <div className="row row-combine2">
                        {/* <p className="row-item">{t('secG_item2_prop4_1')}</p>
                        <p className="row-item">{t('secG_item2_prop4_2')}</p> */}
                    </div>
                    <div className="row">{t('secG_item2_prop5')}</div>
                    <div className="row">{t('secG_item2_prop6')}</div>
                </div>
            </div>
            {langKey !== 'solarspeicher' && (
                <p className="pop-btn" onClick={handleLearMore}>
                    {t('secA_btn')}
                </p>
            )}
            {showQuoteModal && <QuoteModal callback={() => setShowQuoteModal(false)} initType={0} />}
        </div>
    );
}
